var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarlyWarningYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.8509,
    height: 17.8509,
    rx: 8.92546,
    fill: "#FFBA00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14843 3.9668C9.48097 3.9668 9.75504 4.2797 9.7925 4.68281L9.79686 4.77733V9.64056C9.79686 10.0882 9.50655 10.4511 9.14843 10.4511C8.81589 10.4511 8.54182 10.1382 8.50436 9.73509L8.5 9.64056L8.5 4.77733C8.5 4.32969 8.79031 3.9668 9.14843 3.9668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.237304
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14843 13.0449C9.50655 13.0449 9.79686 12.7546 9.79686 12.3965C9.79686 12.0384 9.50655 11.748 9.14843 11.748C8.79031 11.748 8.5 12.0384 8.5 12.3965C8.5 12.7546 8.79031 13.0449 9.14843 13.0449Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.237304
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyWarningYellow);
export default __webpack_public_path__ + "static/media/early_warning_yellow.976b22aa.svg";
export { ForwardRef as ReactComponent };